import { api } from "../../api";
import { OffersResponse, RequestOffersParams } from "./types";
import {
  CreateOfferFieldsType,
  CreateOfferResponse,
} from "../offerCreate/types";

export async function getOffersApi(
  params: RequestOffersParams,
): Promise<OffersResponse> {
  const { data } = await api.get<OffersResponse>("/api/offers", { params });
  return data;
}

export async function downloadPdfApi(
  id: number,
  params: { language: string },
): Promise<Blob> {
  const { data } = await api.get(`/api/offers/${id}/export/pdf`, {
    params,
    responseType: "blob",
  });
  return data;
}

export async function getOfferApi(id: number): Promise<CreateOfferResponse> {
  const { data } = await api.get<CreateOfferResponse>(`/api/offers/${id}`);
  return data;
}

export async function createOfferApi(
  params: CreateOfferFieldsType,
): Promise<CreateOfferResponse> {
  const { data } = await api.post<CreateOfferResponse>("/api/offers", {
    ...params,
  });
  return data;
}

export async function updateOfferApi(
  id: number,
  params: CreateOfferFieldsType,
): Promise<CreateOfferResponse> {
  const { data } = await api.patch<CreateOfferResponse>(`/api/offers/${id}`, {
    ...params,
  });
  return data;
}
export async function deleteOfferApi(offerId: number): Promise<void> {
  await api.delete<CreateOfferResponse>(`/api/offers/${offerId}`);
}
